import { atom, useAtom } from "jotai";
import { useCallback, useMemo } from "react";
import { merchantDetailsState } from "../jotaiState";
export const useMerchant = () => {
  const [merchantDetails, setMerchantDetails] = useAtom(merchantDetailsState);
  const resetMerchantDetails = useCallback(async () => {
    const parsedData = JSON.parse(sessionStorage.getItem("merchantDetails"));

    setMerchantDetails(parsedData);
  }, []);
  const result = useMemo(() => merchantDetails, [merchantDetails]);
  return {
    merchantDetails: result,
    resetMerchantDetails,
  };
};
